require("!!C:\\svn\\trunk\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\trunk\\node_modules\\raw-loader\\index.js!C:\\svn\\trunk\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\trunk\\client-side\\JqueryUI\\jquery-ui.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./client-side/JqueryUI/jquery-ui.min.js
// module id = 80
// module chunks = 0